import { signalStore, withProps } from '@ngrx/signals';
import { ImpersonationService } from '../data/impersonation.service';
import { withCalls } from '@ngrx-traits/signals';
import { inject } from '@angular/core';
import { callConfig } from '@ngrx-traits/signals';
import { ToastService } from '@core/toast';
import { ImpersonationUser } from '../models/impersonation-user.model';
import { AuthStore, isCpoNextNotAllowedError } from '@core/auth';

export const ImpersonationStore = signalStore(
  withProps(() => ({
    _impersonationService: inject(ImpersonationService),
    _toastService: inject(ToastService),
    _authStore: inject(AuthStore),
  })),
  withCalls(({ _impersonationService, _toastService, _authStore }) => ({
    impersonate: callConfig({
      call: (user: ImpersonationUser) =>
        _impersonationService.impersonateUser(String(user.id)),
      mapError: (error) =>
        isCpoNextNotAllowedError(error)
          ? 'Der Mandant dieses Benutzers ist für CPO next nicht freigeschaltet.'
          : 'Fehler beim Impersionieren',
      onError: (error) => _toastService.error(String(error), ''),
      onSuccess: (result, param) => {
        _authStore.setImpersonationTokens(result);
        _toastService.success(
          'Erfolgreich impersoniert als ' + param.email,
          ''
        );
        _authStore.navigateToCases();
      },
    }),
  }))
);
